module.exports = __webpack_public_path__ + "static/img/law.635ed1dd.png";